window.PreTripStudyGuideData = {
  "sections": [
    {
      "id": "engine",
      "number": "01",
      "title": "Engine Compartment",
      "subtitle": "Fluids, steering, belts, hoses, leaks, and engine-mounted components.",
      "memory": "Start high, move front to back, and follow the same order every time.",
      "components": [
        {
          "id": "engine-oil",
          "name": "Engine Oil",
          "critical": false,
          "know": "Engine oil lubricates internal engine parts and helps control heat and wear.",
          "find": "Locate the dipstick and oil-fill area in the engine compartment.",
          "say": "I would check the engine oil level with the vehicle on level ground and the engine off. The level must be within the safe operating range.",
          "check": [
            "Level is within the safe range",
            "No visible leaks",
            "Dipstick and cap are secure"
          ],
          "why": "Low or contaminated oil can cause severe engine damage or failure.",
          "failure": "Loss of lubrication can overheat or seize the engine.",
          "memory": "Level \u2022 Leaks \u2022 Secure",
          "coach": "Do not only point at the dipstick. Explain how you verify the level.",
          "quiz": {
            "question": "What should you confirm when inspecting engine oil?",
            "options": [
              "Only the color",
              "Safe level, leaks, and secure cap",
              "That the engine is running",
              "That the dipstick is removed"
            ],
            "answer": 1,
            "explanation": "A complete inspection checks the operating level, signs of leakage, and that the dipstick and fill cap are secure."
          }
        },
        {
          "id": "coolant",
          "name": "Coolant System",
          "critical": false,
          "know": "Coolant controls engine temperature and protects the cooling system.",
          "find": "Locate the coolant reservoir, radiator area, hoses, and clamps.",
          "say": "I would verify the coolant level is within the safe range and check the reservoir, hoses, and clamps for leaks, cracks, damage, and security.",
          "check": [
            "Correct coolant level",
            "No leaks",
            "Hoses not cracked, swollen, or cut",
            "Clamps secure"
          ],
          "why": "A cooling-system failure can quickly overheat the engine.",
          "failure": "Overheating can disable the vehicle and cause major engine damage.",
          "memory": "Level \u2022 Hoses \u2022 Clamps \u2022 Leaks",
          "coach": "Never remove a hot radiator cap during a real inspection.",
          "quiz": {
            "question": "Which condition is unsafe on a coolant hose?",
            "options": [
              "Firm and secure",
              "Properly clamped",
              "Cracked, swollen, or leaking",
              "Clean exterior"
            ],
            "answer": 2,
            "explanation": "Cracks, swelling, cuts, and leakage can indicate a hose that may fail under pressure."
          }
        },
        {
          "id": "steering-system",
          "name": "Steering System",
          "critical": true,
          "know": "The steering system transfers driver input to the steer axle.",
          "find": "Inspect the steering shaft, gearbox, pitman arm, drag link, steering knuckle, and related hardware.",
          "say": "The steering components must be securely mounted, not cracked, bent, broken, or excessively worn. Castle nuts and cotter pins must be present, and the system must not leak.",
          "check": [
            "Secure mounting",
            "No cracks, bends, or breaks",
            "No missing hardware",
            "No excessive play",
            "No fluid leaks"
          ],
          "why": "Steering defects can cause loss of directional control.",
          "failure": "A disconnected or failed steering component can cause a crash without warning.",
          "memory": "Mounting \u2022 Damage \u2022 Hardware \u2022 Play \u2022 Leaks",
          "coach": "This is safety-critical. Name the components and describe both condition and security.",
          "quiz": {
            "question": "Why are missing cotter pins on steering components serious?",
            "options": [
              "They affect paint quality",
              "They can allow fasteners to loosen",
              "They reduce fuel economy",
              "They make the wheel dirty"
            ],
            "answer": 1,
            "explanation": "Cotter pins help retain critical fasteners. Missing retainers can allow steering hardware to loosen or separate."
          }
        }
      ]
    },
    {
      "id": "driver-side",
      "number": "02",
      "title": "Driver Side",
      "subtitle": "Mirror, door, fuel system, frame, suspension, brakes, wheels, and tires.",
      "memory": "Work top to bottom, then front to rear.",
      "components": [
        {
          "id": "mirrors-door",
          "name": "Mirrors and Door",
          "critical": false,
          "know": "Mirrors provide rear and side visibility; the door and seal protect the driver and cab.",
          "find": "Inspect mirror brackets, glass, door hinges, latch, handle, and weather seal.",
          "say": "The mirrors and brackets are clean, secure, and not cracked or damaged. The door opens, closes, and latches properly, and the seal is intact.",
          "check": [
            "Mirrors clean and not cracked",
            "Brackets secure",
            "Door hinges secure",
            "Latch works",
            "Seal intact"
          ],
          "why": "Poor visibility or an insecure door can create serious driving hazards.",
          "failure": "Reduced visibility can hide vehicles, pedestrians, or obstacles.",
          "memory": "Clean \u2022 Clear \u2022 Secure \u2022 Latches",
          "coach": "Mention both mirror glass and mounting hardware.",
          "quiz": {
            "question": "A complete mirror inspection includes:",
            "options": [
              "Only checking cleanliness",
              "Glass condition and bracket security",
              "Only the passenger mirror",
              "Only checking adjustment"
            ],
            "answer": 1,
            "explanation": "Mirror glass and mounting brackets must both be inspected."
          }
        },
        {
          "id": "fuel-tank",
          "name": "Fuel Tank and Cap",
          "critical": false,
          "know": "The fuel system stores and supplies fuel to the engine.",
          "find": "Inspect the tank, straps, brackets, cap, and surrounding area.",
          "say": "The fuel tank is securely mounted with no leaks or damage. The cap is present, tight, and the seal is in good condition.",
          "check": [
            "Tank secure",
            "Straps and brackets secure",
            "No leaks",
            "Cap tight",
            "Seal intact"
          ],
          "why": "Fuel leaks create fire, environmental, and breakdown risks.",
          "failure": "Leaking fuel can ignite or create a hazardous roadway condition.",
          "memory": "Tank \u2022 Straps \u2022 Leaks \u2022 Cap",
          "coach": "Look underneath and around the tank, not just at the cap.",
          "quiz": {
            "question": "What is most important when checking a fuel tank?",
            "options": [
              "Brand name",
              "Security and absence of leaks",
              "Paint color",
              "Tank age only"
            ],
            "answer": 1,
            "explanation": "A fuel tank must be securely mounted and free of leakage."
          }
        },
        {
          "id": "steer-tire-wheel",
          "name": "Steer Tire and Wheel",
          "critical": true,
          "know": "The steer tire and wheel directly affect traction, steering, and braking.",
          "find": "Inspect the tire tread, sidewalls, valve stem, rim, lug nuts, hub, and seals.",
          "say": "The steer tire has adequate tread depth, is properly inflated, and has no cuts, bulges, or exposed cord. The rim is not cracked or bent, lug nuts are present and tight, and the hub seal is not leaking.",
          "check": [
            "Adequate tread",
            "Proper inflation",
            "No cuts, bulges, or exposed cord",
            "Rim not cracked or bent",
            "Lug nuts secure",
            "No hub-seal leak"
          ],
          "why": "A steer-tire or wheel failure can immediately affect vehicle control.",
          "failure": "A blowout, loose wheel, or failed hub can cause loss of control.",
          "memory": "Tread \u2022 Pressure \u2022 Sidewall \u2022 Rim \u2022 Lugs \u2022 Hub",
          "coach": "Steer tires are safety-critical. Avoid vague wording such as 'looks good.'",
          "quiz": {
            "question": "Which tire condition is unsafe?",
            "options": [
              "Properly inflated",
              "Adequate tread",
              "Bulge or exposed cord",
              "Secure valve cap"
            ],
            "answer": 2,
            "explanation": "Bulges and exposed cord indicate structural tire damage."
          }
        }
      ]
    },
    {
      "id": "coupling",
      "number": "03",
      "title": "Coupling System",
      "subtitle": "Air lines, electrical line, fifth wheel, locking jaws, kingpin, apron, and mounting.",
      "memory": "Connections first, then fifth wheel, then locking security.",
      "components": [
        {
          "id": "air-electrical-lines",
          "name": "Air and Electrical Lines",
          "critical": true,
          "know": "These lines connect tractor braking and electrical systems to the trailer.",
          "find": "Inspect glad hands, seals, hoses, electrical cable, plugs, and supports.",
          "say": "The air and electrical lines are properly connected, supported, and not cut, cracked, chafed, pinched, or leaking. Glad-hand seals are present and the electrical plug is seated and locked.",
          "check": [
            "Correct connections",
            "No cuts or chafing",
            "No leaks",
            "Enough slack for turns",
            "Not dragging",
            "Seals and plugs secure"
          ],
          "why": "Damaged lines can disable trailer brakes or lighting.",
          "failure": "A disconnected air line can apply trailer emergency brakes or eliminate service-brake control.",
          "memory": "Connected \u2022 Supported \u2022 Sealed \u2022 Not Damaged",
          "coach": "Check both damage and routing. Lines should not drag or become stretched during turns.",
          "quiz": {
            "question": "Why must air and electrical lines have proper slack?",
            "options": [
              "To improve appearance",
              "To allow turns without stretching or disconnecting",
              "To reduce tire wear",
              "To cool the engine"
            ],
            "answer": 1,
            "explanation": "Proper slack allows articulation without pulling lines apart or causing damage."
          }
        },
        {
          "id": "fifth-wheel",
          "name": "Fifth Wheel and Mounting",
          "critical": true,
          "know": "The fifth wheel supports the trailer and secures it to the tractor.",
          "find": "Inspect the platform, mounting bolts, sliding mechanism, release arm, safety latch, and lubrication.",
          "say": "The fifth wheel is securely mounted with no cracks, damage, or missing hardware. The release arm is seated, the safety latch is engaged, and the platform is properly lubricated.",
          "check": [
            "Mounting secure",
            "No cracks or breaks",
            "No missing hardware",
            "Release arm seated",
            "Safety latch engaged",
            "Proper lubrication"
          ],
          "why": "A defective or unlocked fifth wheel can allow trailer separation.",
          "failure": "Trailer separation can cause catastrophic loss of control and roadway danger.",
          "memory": "Mount \u2022 Lock \u2022 Latch \u2022 Lubricate",
          "coach": "Do not stop at 'fifth wheel secure.' Describe the release arm, latch, and mounting.",
          "quiz": {
            "question": "What indicates the fifth wheel is secured?",
            "options": [
              "Release arm pulled out",
              "Safety latch disengaged",
              "Release arm seated and safety latch engaged",
              "No lubrication"
            ],
            "answer": 2,
            "explanation": "The release mechanism should be fully seated and protected by the safety latch."
          }
        },
        {
          "id": "jaws-kingpin-apron",
          "name": "Locking Jaws, Kingpin, and Apron",
          "critical": true,
          "know": "The locking jaws capture the kingpin while the trailer apron rests on the fifth wheel.",
          "find": "Look from behind or beneath the fifth wheel using a safe viewing position.",
          "say": "The locking jaws are fully closed around the shank of the kingpin. The kingpin is not bent or damaged, and the trailer apron is lying flat on the fifth wheel with no visible gap.",
          "check": [
            "Jaws fully closed around kingpin shank",
            "Kingpin not bent or damaged",
            "Apron flat on fifth wheel",
            "No gap between apron and fifth wheel"
          ],
          "why": "Incorrect coupling can allow the trailer to detach.",
          "failure": "A high hook or unlocked kingpin can cause trailer drop or separation.",
          "memory": "Jaws Closed \u2022 Kingpin Sound \u2022 No Gap",
          "coach": "Say 'around the shank of the kingpin,' not merely 'around the kingpin.'",
          "quiz": {
            "question": "What does a visible gap between the trailer apron and fifth wheel suggest?",
            "options": [
              "Correct coupling",
              "Possible high hook or improper coupling",
              "Proper lubrication",
              "Correct trailer height"
            ],
            "answer": 1,
            "explanation": "The apron should lie flat on the fifth wheel. A gap may indicate improper coupling."
          }
        }
      ]
    },
    {
      "id": "trailer",
      "number": "04",
      "title": "Trailer",
      "subtitle": "Frame, floor, landing gear, suspension, brakes, tandems, lights, doors, and rear protection.",
      "memory": "Structure, support, running gear, then rear.",
      "components": [
        {
          "id": "landing-gear",
          "name": "Landing Gear",
          "critical": false,
          "know": "Landing gear supports the front of a detached trailer.",
          "find": "Inspect legs, braces, feet, crank handle, and mounting hardware.",
          "say": "The landing gear is fully raised, the crank handle is secure, and the legs, braces, feet, and mounting hardware are not cracked, bent, broken, or loose.",
          "check": [
            "Fully raised",
            "Handle secure",
            "Braces secure",
            "Feet not damaged",
            "No cracks or bends"
          ],
          "why": "Loose or lowered landing gear can strike the roadway or fail during trailer support.",
          "failure": "Road contact can damage the trailer or create a sudden hazard.",
          "memory": "Raised \u2022 Handle \u2022 Braces \u2022 Feet",
          "coach": "Confirm the handle is secured so it cannot swing free.",
          "quiz": {
            "question": "Before travel, landing gear should be:",
            "options": [
              "Partially lowered",
              "Fully raised and secured",
              "Touching the road",
              "Unbraced"
            ],
            "answer": 1,
            "explanation": "Landing gear must be fully raised and secured before driving."
          }
        },
        {
          "id": "trailer-frame-floor",
          "name": "Trailer Frame and Floor",
          "critical": false,
          "know": "The trailer structure supports cargo and transfers loads to the axles and tractor.",
          "find": "Inspect frame rails, cross members, floor, side panels, and visible supports.",
          "say": "The trailer frame, cross members, and floor are secure and free of cracks, bends, breaks, holes, or missing hardware.",
          "check": [
            "No cracks or bends",
            "Cross members present",
            "Floor sound",
            "No major holes",
            "Hardware secure"
          ],
          "why": "Structural damage can reduce load support and trailer stability.",
          "failure": "A weakened floor or frame can fail under cargo weight.",
          "memory": "Frame \u2022 Cross Members \u2022 Floor \u2022 Hardware",
          "coach": "Look underneath for damaged or missing cross members.",
          "quiz": {
            "question": "Why inspect trailer cross members?",
            "options": [
              "They support the floor and cargo",
              "They control mirrors",
              "They power lights",
              "They hold fuel"
            ],
            "answer": 0,
            "explanation": "Cross members support the trailer floor and cargo load."
          }
        },
        {
          "id": "rear-trailer",
          "name": "Rear Doors, Lights, and Protection",
          "critical": true,
          "know": "The rear of the trailer provides cargo security, visibility, and underride protection.",
          "find": "Inspect doors, hinges, latches, lights, reflectors, mud flaps, and rear impact guard.",
          "say": "The rear doors, hinges, and latches are secure. Lights and reflectors are clean, correct in color, and operational. Mud flaps and the rear impact guard are securely mounted and not damaged.",
          "check": [
            "Doors and hinges secure",
            "Latches locked",
            "Lights working",
            "Reflectors clean",
            "Mud flaps secure",
            "Rear impact guard sound"
          ],
          "why": "Rear visibility and cargo security protect following traffic and prevent cargo loss.",
          "failure": "Unsecured doors or failed lights can cause cargo loss or rear-end collisions.",
          "memory": "Doors \u2022 Lights \u2022 Reflectors \u2022 Flaps \u2022 Guard",
          "coach": "Include color, cleanliness, and operation when describing lights and reflectors.",
          "quiz": {
            "question": "A rear-light inspection should include:",
            "options": [
              "Only whether the lens exists",
              "Cleanliness, correct color, security, and operation",
              "Only the left light",
              "Only reflectors"
            ],
            "answer": 1,
            "explanation": "A complete light inspection checks condition, color, security, cleanliness, and operation."
          }
        }
      ]
    },
    {
      "id": "passenger-side",
      "number": "05",
      "title": "Passenger Side",
      "subtitle": "Repeat applicable systems while watching for side-specific hazards and exhaust concerns.",
      "memory": "Do not assume the opposite side is identical\u2014inspect it.",
      "components": [
        {
          "id": "exhaust",
          "name": "Exhaust System",
          "critical": true,
          "know": "The exhaust system routes gases away from the engine and cab.",
          "find": "Inspect pipes, clamps, muffler, brackets, and areas near the cab or fuel system.",
          "say": "The exhaust system is securely mounted with no cracks, holes, leaks, or loose connections. Exhaust is directed away from the cab and no hot components are contacting fuel or electrical lines.",
          "check": [
            "No cracks or holes",
            "No soot indicating leaks",
            "Mounting secure",
            "Directed away from cab",
            "No contact with fuel or wiring"
          ],
          "why": "Exhaust leaks can expose occupants to toxic gases and create fire risk.",
          "failure": "Carbon monoxide can enter the cab, and hot exhaust can ignite nearby materials.",
          "memory": "Secure \u2022 No Leaks \u2022 Away From Cab",
          "coach": "Look for soot, which can reveal leakage even when a hole is hard to see.",
          "quiz": {
            "question": "Why is an exhaust leak near the cab especially dangerous?",
            "options": [
              "It increases mirror vibration",
              "It can allow toxic gases into the cab",
              "It changes tire pressure",
              "It lowers coolant"
            ],
            "answer": 1,
            "explanation": "Exhaust gases, including carbon monoxide, can enter the cab."
          }
        },
        {
          "id": "battery-box",
          "name": "Battery Box",
          "critical": false,
          "know": "The battery supplies electrical power for starting and vehicle systems.",
          "find": "Inspect the battery box, cover, cables, terminals, and mounting.",
          "say": "The battery box and cover are secure. Batteries are properly mounted, terminals are tight, cables are not damaged, and there is no excessive corrosion or leakage.",
          "check": [
            "Box and cover secure",
            "Battery mounted",
            "Terminals tight",
            "Cables undamaged",
            "No excessive corrosion",
            "No leaks"
          ],
          "why": "Loose batteries or damaged cables can cause fire, starting failure, or electrical loss.",
          "failure": "A short circuit can cause fire or disable critical electrical systems.",
          "memory": "Box \u2022 Battery \u2022 Terminals \u2022 Cables",
          "coach": "Mention both physical security and electrical condition.",
          "quiz": {
            "question": "Which battery condition needs attention?",
            "options": [
              "Secure mounting",
              "Tight terminals",
              "Damaged cable or leaking battery",
              "Secure cover"
            ],
            "answer": 2,
            "explanation": "Damaged cables and battery leakage create electrical and chemical hazards."
          }
        }
      ]
    },
    {
      "id": "front",
      "number": "06",
      "title": "Front of Vehicle",
      "subtitle": "Lights, reflectors, windshield, hood, bumper, plate, and visible leaks.",
      "memory": "See and be seen.",
      "components": [
        {
          "id": "front-lights",
          "name": "Front Lights and Reflectors",
          "critical": true,
          "know": "Front lighting makes the vehicle visible and communicates direction and position.",
          "find": "Inspect headlights, high beams, turn signals, hazard lights, clearance lights, and reflectors.",
          "say": "All front lights and reflectors are clean, the correct color, securely mounted, not cracked or damaged, and operating properly.",
          "check": [
            "Correct color",
            "Clean lenses",
            "Secure mounting",
            "No cracks",
            "Operational"
          ],
          "why": "Failed lighting reduces visibility and communication with other road users.",
          "failure": "Other drivers may not see the truck or understand its intended movement.",
          "memory": "Clean \u2022 Correct Color \u2022 Secure \u2022 Working",
          "coach": "Use the same light-inspection phrase consistently throughout the truck.",
          "quiz": {
            "question": "Which phrase best describes a complete light inspection?",
            "options": [
              "Present",
              "Looks fine",
              "Clean, correct color, secure, undamaged, and working",
              "Recently replaced"
            ],
            "answer": 2,
            "explanation": "A full inspection covers condition, mounting, color, cleanliness, and operation."
          }
        },
        {
          "id": "windshield-wipers",
          "name": "Windshield and Wipers",
          "critical": true,
          "know": "The windshield and wipers provide a clear forward view.",
          "find": "Inspect glass, wiper arms, blades, washer nozzles, and visible field of view.",
          "say": "The windshield is clean and free of illegal stickers, major cracks, or obstructions. Wiper arms and blades are secure, not damaged, and make proper contact with the glass.",
          "check": [
            "Clear field of view",
            "No major cracks",
            "No obstructions",
            "Wiper arms secure",
            "Blades not torn",
            "Washer system functional"
          ],
          "why": "Impaired forward visibility makes hazard recognition and vehicle control more difficult.",
          "failure": "Rain, debris, or glare can prevent the driver from seeing the roadway.",
          "memory": "Glass \u2022 View \u2022 Arms \u2022 Blades \u2022 Washer",
          "coach": "Distinguish harmless edge damage from defects that obstruct the driver's field of view according to applicable rules.",
          "quiz": {
            "question": "Why are torn wiper blades unsafe?",
            "options": [
              "They increase fuel use",
              "They may fail to clear the windshield",
              "They loosen lug nuts",
              "They affect trailer height"
            ],
            "answer": 1,
            "explanation": "Damaged blades may not clear water or debris, reducing forward visibility."
          }
        }
      ]
    },
    {
      "id": "in-cab",
      "number": "07",
      "title": "In-Cab Inspection",
      "subtitle": "Safe start, gauges, controls, mirrors, warning devices, emergency equipment, and steering play.",
      "memory": "Secure yourself, start safely, verify systems, then test controls.",
      "components": [
        {
          "id": "safe-start-gauges",
          "name": "Safe Start and Gauges",
          "critical": true,
          "know": "A safe start prevents unintended movement and confirms critical systems begin operating normally.",
          "find": "Use the parking brakes, transmission selector, ignition, and instrument panel.",
          "say": "I will verify the parking brakes are applied and the transmission is in neutral before starting. After starting, I will confirm oil pressure rises, the voltmeter is charging, coolant temperature is normal, and warning lights cycle appropriately.",
          "check": [
            "Parking brakes applied",
            "Transmission in neutral",
            "Oil pressure rises",
            "Charging system works",
            "Temperature normal",
            "Warnings cycle correctly"
          ],
          "why": "Improper starting can move the vehicle unexpectedly or hide mechanical problems.",
          "failure": "The truck can roll, or an engine/system failure may go unnoticed.",
          "memory": "Brakes \u2022 Neutral \u2022 Start \u2022 Gauges \u2022 Warnings",
          "coach": "Say the safe-start sequence in order every time.",
          "quiz": {
            "question": "Before starting the engine, confirm:",
            "options": [
              "Parking brakes released",
              "Transmission in drive",
              "Parking brakes applied and transmission in neutral",
              "Headlights off only"
            ],
            "answer": 2,
            "explanation": "Applying the parking brakes and placing the transmission in neutral reduces unintended movement."
          }
        },
        {
          "id": "emergency-equipment",
          "name": "Emergency Equipment",
          "critical": true,
          "know": "Required emergency equipment supports roadside safety and fire response.",
          "find": "Locate the fire extinguisher, warning triangles, and spare fuses or circuit protection as applicable.",
          "say": "The fire extinguisher is properly rated, charged, pinned, and securely mounted. Three reflective triangles are present, and required spare electrical protection is available unless the vehicle uses resettable circuit breakers.",
          "check": [
            "Extinguisher charged",
            "Pin present",
            "Mount secure",
            "Three triangles",
            "Required spare fuses or breakers"
          ],
          "why": "Emergency equipment protects the driver and other road users after a breakdown or fire.",
          "failure": "A disabled vehicle may be difficult to mark, and a small fire may spread.",
          "memory": "Extinguisher \u2022 Three Triangles \u2022 Electrical Protection",
          "coach": "Do not just count the items. Describe extinguisher condition and security.",
          "quiz": {
            "question": "How many reflective warning triangles are typically checked?",
            "options": [
              "One",
              "Two",
              "Three",
              "Five"
            ],
            "answer": 2,
            "explanation": "The standard inspection commonly verifies three reflective warning triangles."
          }
        }
      ]
    },
    {
      "id": "air-brakes",
      "number": "08",
      "title": "Air Brake Tests",
      "subtitle": "Pressure build, governor operation, leakage, warning devices, spring brakes, and service-brake response.",
      "memory": "Build \u2022 Cut-Out \u2022 Leak \u2022 Warning \u2022 Pop-Out \u2022 Roll",
      "components": [
        {
          "id": "governor",
          "name": "Governor Cut-In and Cut-Out",
          "critical": true,
          "know": "The governor controls when the air compressor begins and stops building pressure.",
          "find": "Observe the air-pressure gauges while building and reducing pressure.",
          "say": "I will verify the governor cuts out at the proper pressure and cuts back in as pressure falls, using the limits required by the vehicle and current testing standard.",
          "check": [
            "Pressure builds normally",
            "Cut-out occurs",
            "Cut-in occurs",
            "Needles respond consistently"
          ],
          "why": "A malfunctioning governor can allow insufficient or excessive air pressure.",
          "failure": "The system may not maintain enough pressure for reliable braking.",
          "memory": "Build \u2022 Stop \u2022 Drop \u2022 Restart",
          "coach": "Use state- or vehicle-specific verified limits. Do not present one universal number when requirements differ.",
          "quiz": {
            "question": "What does governor cut-in mean?",
            "options": [
              "The compressor begins building pressure again",
              "The engine shuts off",
              "The spring brakes release automatically",
              "The horn activates"
            ],
            "answer": 0,
            "explanation": "Cut-in is the pressure point where the governor tells the compressor to resume building air."
          }
        },
        {
          "id": "air-leak-test",
          "name": "Air Leakage Test",
          "critical": true,
          "know": "The leakage test checks whether the air system loses pressure faster than allowed.",
          "find": "Use the gauges with the system charged and follow the correct parking-brake and pedal procedure for the vehicle combination.",
          "say": "I will stabilize the system, follow the required brake-release procedure, and measure pressure loss during the specified time. The loss must remain within the verified limit for this vehicle and jurisdiction.",
          "check": [
            "System fully charged",
            "Procedure followed in correct order",
            "Pressure stabilized",
            "Loss measured accurately",
            "Result within verified limit"
          ],
          "why": "Excessive leakage may leave insufficient pressure for braking.",
          "failure": "A leak can reduce braking ability or cause spring brakes to apply unexpectedly.",
          "memory": "Charge \u2022 Configure \u2022 Stabilize \u2022 Time \u2022 Measure",
          "coach": "Sequence matters. Read the selected state's verified procedure before claiming exact limits.",
          "quiz": {
            "question": "Why must pressure stabilize before measuring leakage?",
            "options": [
              "To improve engine oil",
              "To avoid counting normal initial movement as leakage",
              "To cool the brakes",
              "To release the fifth wheel"
            ],
            "answer": 1,
            "explanation": "Stabilization helps ensure the measured drop reflects actual system leakage."
          }
        },
        {
          "id": "warning-popout-service",
          "name": "Low-Air Warning, Spring Brake, and Service Test",
          "critical": true,
          "know": "These tests confirm the driver receives warning, spring brakes apply, and service brakes stop the vehicle correctly.",
          "find": "Observe warning devices and brake controls while reducing pressure, then perform a controlled low-speed service-brake test.",
          "say": "I will verify the low-air warning activates before pressure becomes dangerously low, the spring-brake controls pop out within the verified range, and the service brakes stop the vehicle without pulling to either side.",
          "check": [
            "Warning activates",
            "Spring-brake controls pop out",
            "Vehicle remains controlled",
            "Service brake stops smoothly",
            "No pull or unusual response"
          ],
          "why": "These systems protect the driver when air pressure is lost and confirm the brakes respond evenly.",
          "failure": "Missing warnings or uneven braking can cause delayed response, wheel lock, or loss of control.",
          "memory": "Warning \u2022 Pop-Out \u2022 Roll \u2022 Stop Straight",
          "coach": "Keep the vehicle area clear and follow the correct sequence. Never perform movement tests without a safe path.",
          "quiz": {
            "question": "What should happen during a service-brake test?",
            "options": [
              "The vehicle pulls sharply",
              "The vehicle stops smoothly without pulling",
              "The spring brakes pop out immediately",
              "The engine stalls"
            ],
            "answer": 1,
            "explanation": "The service brakes should stop the vehicle smoothly and evenly without pulling."
          }
        }
      ]
    }
  ]
};
